export interface ApiValidationError {
    code: string
    message: string
    parameters?: Record<
        string,
        string | number
    >
}

export interface ApiProblemDetails {
    type?: string
    title?: string
    status?: number
    detail?: string
    instance?: string

    code?: string

    errors?: Record<
        string,
        ApiValidationError[]
    >

    traceId?: string
}
interface ApiErrorOptions {
    status?: number
    errorCode?: string
    transportCode?: string
    problem?: ApiProblemDetails
    isNetworkError?: boolean
}

export class ApiError extends Error {
    readonly status?: number

    readonly errorCode?: string

    readonly transportCode?: string

    readonly problem?: ApiProblemDetails

    readonly isNetworkError: boolean

    constructor(
    message: string,
    options: ApiErrorOptions = {},
) {
    super(message)

    this.name = 'ApiError'
    this.status = options.status
    this.errorCode = options.errorCode
    this.transportCode =
        options.transportCode
    this.problem = options.problem
    this.isNetworkError =
        options.isNetworkError ?? false
}

    get isUnauthorized(): boolean {
        return this.status === 401
    }

    get isForbidden(): boolean {
        return this.status === 403
    }

    get isValidationError(): boolean {
        return (
            this.status === 400 ||
            this.status === 422
        )
    }
}